import { render, staticRenderFns } from "./AdminModalMenu.vue?vue&type=template&id=228b0608&scoped=true&"
import script from "./AdminModalMenu.vue?vue&type=script&lang=js&"
export * from "./AdminModalMenu.vue?vue&type=script&lang=js&"
import style0 from "./AdminModalMenu.vue?vue&type=style&index=0&id=228b0608&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228b0608",
  null
  
)

export default component.exports